import * as React from "react";
// import * as Scrollbars from 'react-custom-scrollbars';
// import * as Lodash from 'lodash';
// import * as i18next from 'i18next';
// import * as Utils from '@Cyclope-Utils/index';
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onSortingAZ,
    onSortingZA,
    /* cameras , label ,section, onSearch */ dateBoolean,
    chiffreBoolean,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @name react-custom-scrollbars
   * @name i18next
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <div className="actionTextSorting">
      {chiffreBoolean && (
        <p onClick={onSortingAZ}>{i18next.t("trier par ordre croissant")}</p>
      )}
      {chiffreBoolean && (
        <p onClick={onSortingZA}>{i18next.t("trier par ordre decroissant")}</p>
      )}
      {!dateBoolean && !chiffreBoolean && (
        <p onClick={onSortingAZ}>{i18next.t("trier de a -> z")}</p>
      )}
      {!dateBoolean && !chiffreBoolean && (
        <p onClick={onSortingZA}>{i18next.t("trier de z -> a")}</p>
      )}
      {dateBoolean && <p onClick={onSortingAZ}>{i18next.t("plus ancien")}</p>}
      {dateBoolean && <p onClick={onSortingZA}>{i18next.t("plus recent")}</p>}
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onSortingAZ?: any;
  onSortingZA?: any;
  cameras?: any;
  label?: any;
  section?: any;
  onSearch?: any;
  dateBoolean?: boolean;
  chiffreBoolean?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/sorting/component.tsx